import React from "react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { Card } from "./Card";

/**
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.toggle
 * @param {React.ReactNode} children
 * @returns
 */
export const Modal = ({ isOpen, toggle, children }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      toggle();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={handleOverlayClick}
    >
      <Card style={{ padding: "1rem", position: "relative" }}>
        <button
          onClick={toggle}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          <XMarkIcon style={{ width: "24px", height: "24px", color: "#333" }} />
        </button>
        <div style={{ marginRight: "1.5rem" }}>{children}</div>
      </Card>
    </div>
  );
};
